module.exports = __webpack_public_path__ + "static/img/Full-Body2.60b05fc0.jpg";